<template>
  <v-progress-linear
    :height="height"
    :rounded="rounded"
    :color="color"
    :value="value"
    :background-color="backgroundColor"
    :dark="dark"
    :buffer-value="bufferValue"
    :indeterminate="indeterminate"
  >
  </v-progress-linear>
</template>

<script>
/**
 * @displayName Linear Progress
 */
export default {
  name: 'ZLinearProgress',
  props: {
    /**
     * Valor do componente (progress bar)
     */
    value: {
      type: [String, Number],
      required: true,
    },
    /**
     * Define a altura da progress bar
     */
    height: {
      type: [Number, String],
      required: false,
    },
    /**
     * Valor do buffer
     */
    bufferValue: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    /**
     * Define a cor da progress bar
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * Define a cor de background
     */
    backgroundColor: {
      type: String,
      required: false,
    },
    /**
     * Aplica a variante dark no componente
     */
    dark: {
      type: Boolean,
      required: false,
    },
    /**
     * Aplica animação de loading no componente
     */
    indeterminate: {
      type: Boolean,
      required: false,
    },
    /**
     * Aplica estilo arredondado no componente
     */
    rounded: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style></style>
